import { PaymentTransactionDto } from './payment-transaction-dto';

export class PaymentTransactionWiredTransferDto extends PaymentTransactionDto {
  constructor(public referenceNumber: string, paymentDate: Date, paymentMethodId: number) {
    super(paymentDate, paymentMethodId);
  }
}
